import React, { useEffect } from "react";
import makeStyles from "@mui/styles/makeStyles";
import Tooltip from "@mui/material/Tooltip";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  customTooltip: {
    fontSize: "14px",
    lineHeight: "19px",
    padding: "2px 12px 3px 12px",
    width: "fit-content",
    maxWidth: "95vw",
    marginTop: (props) => (props.margin ? "7px" : "9px"),
  },
}));

const TooltipCustom = (props) => {
  const { arrow, title, children, margin, field } = props;

  const classes = useStyles({ margin });
  const [headlineWidth, setHeadlineWidth] = React.useState(0);
  const [currentHeadlineWidth, setCurrentHeadlineWidth] = React.useState(0);
  const state = useSelector(
    (state) =>
      state.contacts.columnSize.find((col) => col.colId === field)?.width
  );

  const typeContacts = useSelector((state) => state.contacts.typeContacts);

  useEffect(() => {
    function measureTextCanvas(text, font) {
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      context.font = font;
      return context.measureText(text).width;
    }
    setCurrentHeadlineWidth(measureTextCanvas(title, "15.669px Open Sans"));

    setTimeout(() => {
      const dataSizeTable =
        typeContacts !== "single"
          ? JSON.parse(localStorage?.getItem("contactsGridSettings"))
          : JSON.parse(localStorage?.getItem("executionsGridSettings"));

      const getColumnWidthByColId = (colId) => {
        const column = dataSizeTable?.find((column) => column.colId === colId);
        return column ? column.width : undefined;
      };

      const width = getColumnWidthByColId(field);

      setHeadlineWidth(width);
    }, 100);
  }, [state]);

  return title && currentHeadlineWidth > headlineWidth ? (
    <Tooltip
      classes={{ tooltip: classes.customTooltip }}
      title={
        <div>
          {title?.split("\n").map((paragraph, index) => (
            <p key={index} style={{ minHeight: "12px" }}>
              {paragraph}
            </p>
          ))}
        </div>
      }
      enterDelay={500}
      enterNextDelay={500}
      leaveDelay={0}
      arrow={arrow}
    >
      {children}
    </Tooltip>
  ) : (
    children
  );
};

export default TooltipCustom;
